import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../../config/api";
import useAuth from "../../../hook/useAuth";
import EmailValidatedToCheckExistComponent from "../../../components/EmailValidatedToCheckExistComponent";
import { DoesEmailExist, DoesUserNameExist } from "../../../services/Users";
import UsernameValidatedComponent from "../../../components/UsernameValidatedComponent";
import { PhoneNumberInput } from "../../../components/PhoneNumberInput";
import PasswordValidation from "../../../components/PasswordValidation";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup";

export const AddUser = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [userName, setUserName] = useState<string>("");
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [mobilPhoneNumber, setMobilePhoneNumber] = useState<string>("");
    const [usernameTouched, setUsernameTouched] = useState<boolean>(false);
    const [emailTouched, setEmailTouched] = useState<boolean>(false);
    const [isValidPassword, setIsValidPassword] = useState<boolean>(false);
    const [enabled, setEnabled] = useState<string>("Yes");
    const [dateFormat, setDateFormat] = useState<string>("MM/dd/yyyy KK:mm a");
    const [roleId, setRoleId] = useState<string>("");
    const [roleOptions, setRoleOptions] = useState([]);
    const [passwordTouched, setPasswordTouched] = useState<boolean>(false);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    useEffect(() => {
        axios.get(`${baseURL}roles`)
            .then((response) => {
                setRoleOptions(response?.data?.map((item: any) => {
                    return { value: item.id, label: item.roleName }
                }))

                setRoleId(response?.data[0]?.id || "0")
            }).catch(error => {
                setRoleId("0");
                console.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);

        await axios
            .post(
                `${baseURL}users?userId=${auth?.id}`,
                JSON.stringify({
                    firstName,
                    lastName,
                    userName,
                    password,
                    mobilPhoneNumber,
                    emailAddress,
                    profilePic: "",
                    bio: "",
                    isActive: enabled === "Yes" ? true : false,
                    roleId,
                    dateFormat,
                    language: "English",
                    createdAt: new Date().toLocaleString(),
                    createdBy: auth?.givenname,
                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }

    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <h2 className={`text-lg font-semibold`}>Add User</h2>

                    <div className="mt-2 p-2">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    {/* First Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">First Name</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={firstName}
                                                placeholder="First Name"
                                                onChange={(e) => setFirstName(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <EmailValidatedToCheckExistComponent
                                            email={emailAddress}
                                            setEmail={setEmailAddress}
                                            getEmail={DoesEmailExist}
                                            touched={emailTouched}
                                            setTouched={setEmailTouched}
                                            className={{
                                                parentDiv: "",
                                                label: "block text-xs font-medium text-secondary",
                                                input:
                                                    "w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent",
                                            }}
                                        />

                                        <UsernameValidatedComponent
                                            userName={userName}
                                            setUserName={setUserName}
                                            getUsername={DoesUserNameExist}
                                            touched={usernameTouched}
                                            setTouched={setUsernameTouched}
                                            className={{
                                                parentDiv: "",
                                                label: "block text-xs font-medium text-secondary",
                                                input:
                                                    "w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent",
                                            }}
                                        />

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Date Format</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border border-secondary rounded-md outline-none focus:border-primary text-sm bg-transparent`}
                                                value={dateFormat}
                                                onChange={(e) => setDateFormat(e.target.value)}
                                            >
                                                <option value="MM/dd/yyyy KK:mm a">Use System Default</option>

                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Active</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border border-secondary rounded-md outline-none focus:border-primary text-sm bg-transparent`}
                                                value={enabled}
                                                onChange={(e) => setEnabled(e.target.value)}
                                            >
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>

                                            </select>
                                        </div>
                                    </div>

                                    {/* Second Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Last Name</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={lastName}
                                                placeholder="Last Name"
                                                onChange={(e) => setLastName(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Mobile Number</label>
                                            <PhoneNumberInput
                                                name={"phoneNumber"}
                                                value={mobilPhoneNumber}
                                                setValue={setMobilePhoneNumber}
                                                fontSize={"14px"}
                                                required={true}
                                            />
                                        </div>

                                        <PasswordValidation
                                            password={password}
                                            setPassword={setPassword}
                                            isValid={isValidPassword}
                                            setIsValid={setIsValidPassword}
                                            touched={passwordTouched}
                                            setTouched={setPasswordTouched}
                                            className={{
                                                parentDiv: "relative",
                                                label: "block text-xs font-medium text-secondary",
                                                input:
                                                    "w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent",
                                            }}
                                        />

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Role</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border border-secondary rounded-md outline-none focus:border-primary text-sm bg-transparent`}
                                                value={roleId}
                                                onChange={(e) => setRoleId(e.target.value)}
                                            >
                                                {roleOptions?.map((role: any) => (
                                                    <option key={role.value} value={role.value}>
                                                        {role.label}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>

    )
}